import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { List } from './components/List';
import { Detail } from './components/Detail';

const breadcrumbs: Array<PageLink> = [
  { title: 'Boletera', path: '/boletera/eventos/', isActive: false },
];

const EventosBoleteraPage: React.FC = () => {
  const { path: rawPath } = useRouteMatch();
  const path = rawPath.replace(/\/$/, '');

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Eventos y niveles</PageTitle>
      <Switch>
        <Route exact path={path} component={List} />
        <Route path={`${path}/:id`} component={Detail} />
      </Switch>
    </>
  );
};

export { EventosBoleteraPage };
